<template>
  <!-- <div class="App"> -->
  <div class="Room">

    <Characters class="layer3" />
    <Scenes class="layer3" />
    <Items class="layer3" />
    <Setting class="layer3" />

    <Table class="layer1">
      <ImageObjects />
      <CharacterPieces />
      <!-- <div slot="step">
        <ChatApp />
      </div> -->
      <!-- <CharacterPanels slot="step" /> -->
      <!-- <ChatApp slot="step" /> -->
    </Table>

    <Menu class="layer4" />

    <CharacterDetail class="layer4" />
    <ItemDetail class="layer4" />
    <ImageSelector class="layer5" />
    <SoundSelector class="layer5" />
    <ModeSelector class="layer6" />
    <ItemList class="layer2" />
    <Dice class="layer2" />

    <CharacterList class="layer2" />
    <ChatApp class="layer2" />
    <!-- <Chat class="layer4" /> -->
    <Tracks class="layer2" />

    <Background />
  </div>
  <!-- <div class="ChatApp">
    <ChatApp />
  </div>
  </div> -->
</template>

<script>
const Contents = [
  'Menu',
  'Characters',
  'CharacterDetail',
  'CharacterList',
  'CharacterPieces',
  'CharacterPanels',
  'ImageObjects',
  'Messages',
  'Chat',
  'ChatApp',
  'Scenes',
  'Items',
  'ItemDetail',
  'ItemList',
  'ImageSelector',
  'SoundSelector',
  'Tracks',
  'Table',
  'Background',
  'Login',
  'Setting',
  'ModeSelector',
  'Dice'
].reduce((componentsObj, componentName) => {
  componentsObj[componentName] = require(`./components/contents/${componentName}.vue`).default
  return componentsObj
}, {})

export default {
  name: 'app',
  components: {
    ...Contents
  },
  mounted() {
  },
  computed: {
    tableScale() {
      return this.$store.getters['local/tableScale']
    }
  },
  methods: {
  }
}
</script>

<style lang="scss">
* { margin: 0; padding: 0; }
.App {
 display: flex;
 height: 100%;
}
html, body {
  height: 100%;
}
body {
  background-color: #30353E;
  font-size: 14px;
  font-family: sans-serif;
}
a {
  cursor: pointer;
}
img {
  vertical-align: middle;
  max-width: 100%;
  max-height: 100%;
}
.no-scroll-bar .ps__scrollbar-y-rail {
  display: none !important;
}
.layer1 {
  position: relative;
  z-index: 1;
}
.layer2 {
  position: relative;
  z-index: 10;
}
.layer3 {
  position: relative;
  z-index: 100;
}
.layer4 {
  position: relative;
  z-index: 1000;
}
.layer5 {
  position: relative;
  z-index: 10000;
}
.layer6 {
  position: relative;
  z-index: 100000;
}
.Room {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  position: relative;
}
.m-ellipsis {
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
/* TODO: module化 */
.edit .item {
}
.edit .item + .item {
  margin-top: 8px;
}
.edit .item .name {
  margin-bottom: 4px;
  font-size: 12px;
  font-weight: 800;
  color: #ccc;
}
.edit .item .inputGroup {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.edit .item .inputGroup .input {
  margin-bottom: 5px;
  width: 48%;
}
.edit .item .input {
}
.edit .item .input .label {
  font-size: 10px;
  color: #ccc;
}
input[type=text],
input[type=number],
textarea {
  outline: none;
  box-sizing: border-box;
  padding: 5px 7px;
  border: 2px solid #222;
  display: block;
  width: 100%;
  font-size: 12px;
  color: #ccc;
  background: rgba(0, 0, 0, 0.2);
}
input[type=text],
input[type=number] {
  border-radius: 20px;
}
textarea {
  display: block;
  border-radius: 5px;
  height: 120px;
  resize: none;
}
.pointer {
  position: fixed;
  z-index: 999;
  background: #000;
  color: #fff;
}
.youtube {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
}
</style>
